<template>
  <div>
    <div v-if="activeOvereno" class="mb-1 shaim-aio-consent">
      <div class="form-check shaim-heureka-consent">
        <input id="shaim_aio_heureka_consent" type="checkbox" class="form-check-input" :checked="!consents.customerSatisfactionSurvey" @change="updateValue">
        <label class="form-check-label" for="shaim_aio_heureka_consent">
          {{ translations['I disagree with participating in customer satisfaction survey'] }}
        </label>
      </div>
    </div>
    <div v-if="activeZbozi" class="mb-3 shaim-zbozi-consent">
      <div class="form-check">
        <input id="shaim_aio_zbozi_consent" type="checkbox" class="form-check-input" :checked="shaimAio.zbozi" @change="updateZboziValue">
        <label class="form-check-label" for="shaim_aio_zbozi_consent">
          {{ translations['I agree with participating in customer satisfaction survey Zboží.cz'] }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      consents: state => state.consents,
      modules: state => state.config.modules,
      shaimAio: state => state.shaimAio,
    }),
    module () {
      return this.modules.shaim_aio ? this.modules.shaim_aio : null;
    },
    activeOvereno () {
      return !!(this.module && this.module.enabled && this.module.overeno_checkbox);
    },
    activeZbozi () {
      return this.module && this.module.enabled && this.module.zbozi_checkbox;
    }
  },
  methods: {
    updateValue (e) {
      this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', !e.target.checked);
    },
    updateZboziValue (e) {
      this.$store.commit('SET_SHAIM_AIO_ZBOZI', e.target.checked);
    }
  },
  mounted: function() {
    if (this.active === false) {
      return;
    }
    this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', true);
  },
};
</script>

<style scoped>
.shaim_aio_heureka_consent_link {
  text-decoration: underline;
}
</style>
